/**
 * Implements Trades Saga
 * Main idea is to fetch trades each time new block mined for ETH
 */
import { takeLatest, put, call } from 'redux-saga/effects';
import { LOAD_REGISTRY, actionRegistryLoaded } from '../actions/registry';
import { RegistryAPI } from '../store/createStore';

function* onLoadRegistry(): any {
  try {
    if ((window as any).info_data) {
      yield put(actionRegistryLoaded((window as any).info_data));
    } else {
      const data: any = yield call(RegistryAPI.fetchUIInfo);
      if (data) {
        yield put(actionRegistryLoaded(data));
      }
    }
  } catch (err) {
    console.error(err);
  }
}

export default function* registrySaga() {
  yield takeLatest(LOAD_REGISTRY, onLoadRegistry);
}
